<template>
  <div class="waste">
    <CastomGraphic
        :received-data="receivedData"
        graph-type="line"
        index-axis="x"
        id="vehicle-house"
        :is-title="false"
        :aspect-ratio="2"
        :data-labels="false"
        :maintain-aspect-ratio="true"
    />
  </div>
</template>
<script>
import graphApi from '@/api/graphApi'

export default {
  name: "HouseholdWastePerCapita",
  components: {
    CastomGraphic: () => import('@/components/graph/CastomGraphic.vue'),
  },
  computed: {
    receivedData () {
      return graphApi.householdWastePerCapita()
    },
  }
}
</script>
